"use strict";
// _partialFile.js

{
  (function () {
    const viewport = document.querySelector('meta[name="viewport"]');
    const MIN_WIDTH = 375;
    const NORMAL_VIEW = `width=device-width,initial-scale=1`;
    const FIXED_VIEW = `width=${MIN_WIDTH}`;

    if (!viewport) return;

    const applyViewport = () => {
      const currentWidth = window.innerWidth;
      const value = currentWidth < MIN_WIDTH ? FIXED_VIEW : NORMAL_VIEW;

      if (viewport.getAttribute("content") !== value) {
        viewport.setAttribute("content", value);
      }
    };

    window.addEventListener("resize", applyViewport, false);
    window.addEventListener("orientationchange", applyViewport, false);
    applyViewport();
  })();
}
